export default __webpack_public_path__ + "static/media/royal.b30da248.jpg";